import Vue from "vue";

import VerificationConfirmation from "./VerificationConfirmation.vue";

export function load() {
    const selector = "verification-confirmation";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(VerificationConfirmation, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}